<template>
    <ul class="level0">

        <!-----------------------
              SubMenu List
      ------------------------>
        <li class="submenu-category-list">
            <span @click="backToMainMenuMobile" class="category-label-mobile">{{ menuName }}</span>
            <ul>
                <li
                    v-for="(categorie, key) in categories"
                    :key="key"
                    :id="'icon-category-node-'+categorie.entity_id"
                    :class="[
                        navIndex+(key+1),
                        typeMenu,
                        categorie.css_class,
                        tabActive == navIndex+(key+1) ? 'active' : '',
                    ]"
                    class="level1 gtm-element"
                    @mouseover="setAtciveTab(navIndex+(key+1))"
                    :data-gtmtext="categorie.name"
                    :data-gtmlink="setUrl(categorie)"
                >
                    <ObfuscateLink v-if="obfuscate" :dataHref="setUrl(categorie)" :className="'level1'">
                        <template v-slot:content>
                            <span>
                                {{ categorie.name }}
                            </span>
                        </template>
                    </ObfuscateLink>
                    <a
                        v-else
                        :href="setUrl(categorie)"
                        class="level1"
                    >
                        <span>
                            {{ categorie.name }}
                        </span>
                    </a>
                </li>
            </ul>
        </li>

        <!-----------------------
        Sub-menu Children Content
        ------------------------>
        <li class='submenu-container'>
            <div
                v-for="(categorie, key) in categories"
                :key="key"
                :class="['mega-submenu-'+navIndex+(key+1), tabActive == navIndex+(key+1) ? 'active' : '']"
                class="megamenu-submenu"
            >
                    <!-- Submenu-product CTA top for mcp-->
                    <div v-if="typeMenu == 'subproduct-menu' && !isZeborne" class='submenu-cta' :inner-html.prop="categorie.cms_cta"></div>
                    
                    <div class="submenu-content">
                        <div v-if="typeMenu == 'subproduct-menu'" class='submenu-filtering submenu_mobile' :inner-html.prop="categorie.cms_filtered_list"></div>
                        <div v-if="typeMenu == 'subproduct-menu'" class='submenu-brand' :inner-html.prop="categorie.cms_our_brand"></div>  
                        <div v-if="typeMenu == 'subproduct-menu'" class='submenu-aids' :inner-html.prop="categorie.cms_purchase_aids"></div>
                        <div v-if="typeMenu == 'subproduct-menu'" class='submenu-push-marketing' :inner-html.prop="categorie.cms_push_marketing"></div>
                    </div>

                    <!-- Submenu-product CTA bottom for zeborne-->
                    <div v-if="typeMenu == 'subproduct-menu' && isZeborne" class='submenu-cta' :inner-html.prop="categorie.cms_cta"></div>
                  
                    <!-- Submenu-service -->
                    <div v-if="typeMenu != 'subproduct-menu'" :inner-html.prop="categorie.landing_page"></div>
            </div>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';

export default {
    name: 'SubMenu',

    data() {
        return {
            navIndex: this.typeMenu == 'subproduct-menu' ? 'nav-1-' : 'nav-4-',
            tabActive: '',
        };
    },

    components: {
        ObfuscateLink
    },

    props: {
        categories: {
            type : Object,
            required:true,
        },

        typeMenu: {
            type: String,
            required: false,
        },

        menuName: {
            type: String,
            required: false
        },
        baseUrl: {
            type: String,
            required: false,
            default: process.env.VUE_APP_API_BASE_URL
        },
        obfuscate: {
            type: Boolean,
        },
    },

    computed: {
        ...mapGetters({ isZeborne: "isZeborne" }),
    },

    methods: {
        setAtciveTab(tab) {
            this.tabActive = tab;
        },

        backToMainMenuMobile() {
            this.$emit('displayMainMenuMobile');
        },

        addUrlSlash(url) {
            return url.charAt(0) !== '/' ? `/${url}` : url;
        },

        formatUrl(url) {
            let newUrl = url;

            switch (true) {
                case url.includes('{{baseSecureUrl}}'):
                return newUrl = url.replace('{{baseSecureUrl}}', `${this.baseUrl}/`);
                case url.includes('{{baseUrl}}'):
                return newUrl = url.replace('{{baseUrl}}', `${this.baseUrl}/`);
                case url.startsWith('http'):
                return newUrl = url;
                default: 
                return newUrl = this.baseUrl + this.addUrlSlash(url);
            }
        },

        setUrl(categorie) {
            return categorie.category_url_redirect_menu ? 
                    this.formatUrl(categorie.category_url_redirect_menu) :
                        (categorie.soon_category_url_redirect ? 
                            this.formatUrl(categorie.soon_category_url_redirect) : this.formatUrl(categorie.url_path));
        },
    },

    created() {
        this.tabActive = this.navIndex + '1';
    },

    mounted() {
        // *** Category listing ***
        document.querySelectorAll('.headerMcp.catalog-category-view .nav-content>li.level0 .submenu-container .megamenu-submenu a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        document.querySelectorAll('.headerMcp.catalog-category-view .nav-content>li.level0>.submenu-fullcms .picture-list .picture-item a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        document.querySelectorAll('.headerMcp.catalog-category-view .nav-content>li.level0.secondary-menu .submenu-category-list ul li.level1>a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        // *** Product Page ***
        document.querySelectorAll('.headerMcp.catalog-product-view .nav-content>li.level0 .submenu-container .megamenu-submenu a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        document.querySelectorAll('.headerMcp.catalog-product-view .nav-content>li.level0>.submenu-fullcms .picture-list .picture-item a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        document.querySelectorAll('.headerMcp.catalog-product-view .nav-content>li.level0.secondary-menu .submenu-category-list ul li.level1>a:not(.no-obf)').forEach(function(item) {
            Obfuscation(item);
        });

        function Obfuscation(el) {
            var obfLink = el.getAttribute('href');
            el.dataset.hrefObf = btoa(obfLink);
            el.style.cursor = "pointer";

            el.addEventListener('click', function(e) {
                var link = atob(this.dataset.hrefObf);
                window.open(link, "_self");
            });

            setTimeout(() => {
                el.removeAttribute('href');
            }, "1000");
        }
    },
    
}
</script>
